export enum NoteColor {
  WHITE, GREEN, BLUE, RED, VIOLET, ORANGE, BLACK, PINK
}